import { ArrowRight } from "lucide-react";
import React, { useEffect } from "react";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { getReason } from "../../redux/actionCreator";
import { useDispatch, useSelector } from "react-redux";
import { reason_list } from "../../redux/commonReducer";
import Select from "react-select";
import { Col } from "react-bootstrap";

const DonationSection = ({
  setStep,
  step,
  onChangeHandler,
  data,
  err,
  setErr,
  setData

}) => {
  const dispatch = useDispatch()
  const reasonDonation = useSelector(reason_list)
  const { t, i18n } = useTranslation();
  const langSwitch = i18n?.language === 'en'
  useEffect(() => {
    dispatch(getReason())
  }, [])

  if (step !== 1) return null;

  const validate = () => {
    let temp = {};
    if (Number(data?.amount) <= 0) {
      temp = {
        ...temp,
        amount: t("please enter donation amount"),
      };
    }
    if (!data?.reason_donation?.trim()?.length) {
      temp = {
        ...temp,
        reason_donation: t("please enter reason"),
      };
    }
    if (Object.values(temp).length != 0) {
      setErr(temp);
      return false;
    } else {
      setErr({});
      return true;
    }
  };

  const nextHandler = () => {
    if (validate()) {
      setStep(2);
    }
  };

 const reasonOptions = reasonDonation?.map(item => ({
  label: langSwitch ? item.reason : item.reason_ar,
  value:langSwitch ? item.reason : item.reason_ar,
}));


  const handleReason = (selectedOption) => {
    setErr((prev) => ({
      ...prev,
      reason_donation: "",
    }));

    setData((prev) => ({
      ...prev,
      reason_donation: selectedOption?.value || "",
    }));
  };

  return (
    <div>
      <div className="modal-amount padding_section">
        <h5 className="modal-amount-title">{t("how much you wish to donate?")}</h5>
        <div className="modal-amount-slider">
          <div className="slider-container">
            <p
              className="amount-value"
              style={{
                ...(langSwitch
                  ? { left: `calc(${(data?.amount / 100000) * 100}% - ${(data?.amount / 100000) * 100 > 80 ? "100px" : "12px"})` }
                  : { right: `calc(${(data?.amount / 100000) * 100}% - 12px)` }
                ),
                whiteSpace: 'nowrap'
              }}
            >
              {data?.amount} AED
            </p>
            <input
              type="range"
              min="0"
              max="100000"
              value={data?.amount}
              onChange={(e) => onChangeHandler("amount", Number(e.target.value))}
              step={10}
              style={{
                backgroundSize: `${(data?.amount / 100000) * 100}% 100%`
              }}
            />
          </div>
        </div>

        <div className="modal-amount-input">
          <input
            type="number"
            value={data?.amount || ""}
            onChange={(e) => onChangeHandler("amount", Number(e.target.value))}
            placeholder={t("enter manually")}
            min={0}
            max={100000}
            className="form-control"
          />
          <span>AED</span>
        </div>
        <p className="error">{err?.amount}</p>
      </div>
      <div className="divider"></div>
      <div className="modal-reason padding_section">
        <label className="modal-reason-label">{`${t("reason for donation")} *`}</label>
        <Col md={6} className="ps-0">
          <div className="form-group mb-3">
            <Select
              options={reasonOptions}
              value={reasonOptions?.find(option => option.value === data?.reason_donation) || null}
              onChange={handleReason}
              className="country_text"
              placeholder={`${t('reason for donation')} *`}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: "33px",
                  boxShadow: "none",
                  borderColor: state.isFocused ? "#ccc" : "#ced4da",
                 
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  height: "33px",
                  padding: "0px 6px",
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  height: "33px",
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected
                    ? "transparent"
                    : state.isFocused
                      ? "transparent"
                      : "white",
                  color: "var(--primary-color)",
                  cursor: "pointer",
                }),
              
              }}
            />

          </div>
        </Col>
        <p className="error">{err?.reason_donation}</p>
      </div>
      <div className="modal-next">
        <button onClick={() => nextHandler()}>
          {t("next")}
          <img src="/assets/img/Group 164.svg" alt="good" className={`mx-2 ${i18n?.language !== "en" ? "arrow_image" : ""}`} />
        </button>
      </div>
    </div>
  );
};

export default DonationSection;
